<template>
    <div>
        <breadcrumbs
            :title="'Vrste podtema'"
            :breadcrumbs="breadcrumbs"
        ></breadcrumbs>
        <div class="ibox">
            <div class="ibox-title">
                <h5>Nova vrsta podteme</h5>
            </div>
            <div class="ibox-content">
                <vrsta-teme2-forma
                    :disabled="false"
                    :id="null"
                    :modal="false"
                    :action="'create'"
                ></vrsta-teme2-forma>
            </div>
        </div>
    </div>
</template>

<script>
import Breadcrumbs from "../../../../components/breadcrumbs/Breadcrumbs";
import VrstaTeme2Forma from "./VrstaTeme2Forma";
export default {
    name: "VrstaTeme2Create",
    components: {
        VrstaTeme2Forma,
        Breadcrumbs
    },
    data(){
        return {
            breadcrumbs: []
        }
    },
    methods: {
        setBreadcrumbs(){
            this.breadcrumbs = [
                {
                    path: '/postavke/vrste-tema2',
                    name: 'Vrste tema'
                },
                {
                    path: '/postavke/vrste-tema2/create',
                    name: 'Nova vrsta teme'
                }
            ]
        }
    },
    mounted(){
        this.setBreadcrumbs()
    }
};
</script>

<style scoped>

</style>
